import {format} from 'date-fns'
import useApi from '../../../services/useApi'
import useFilters from '../../../hook/useFilters'
import {parseCalendarEvents} from '../parsings'
import moment from 'moment'

export const useGetCalendarEvents = () => {
  const Api = useApi()

  const initialFilters = {
    search: '',
    store_filter: '',
    supplier_filter: '',
    start_date: format(moment().startOf('month').toDate(), 'yyyy-MM-dd'),
    end_date: format(moment().endOf('month').toDate(), 'yyyy-MM-dd'),
  }

  const {filters, onSearch, setMultipleFilters} = useFilters(initialFilters)

  const {data: response, isFetching} = Api.useGetQuery('/analytics/zoho/payment/calendar', {
    queryId: 'payment-calendar-events',
    filters: filters,
    isCaching: true,
    isToast: false,
  })

  const updateCalendarMonth = (range: any) => {
    setMultipleFilters({
      start_date: range.start,
      end_date: range.end,
    })
  }

  const onApplyCalendarFilters = (data: any) => {
    setMultipleFilters({
      store_filter: data.store !== '' ? data.store : '',
      supplier_filter: data.suppliers || '',
    })
  }

  const resetCalendarFilters = () => {
    setMultipleFilters({
      store_filter: '',
      supplier_filter: '',
      search: '',
    })
  }

  return {
    calendarEvents: parseCalendarEvents(response?.data) || [],
    filters,
    isLoading: isFetching,
    onSearch,
    onApplyCalendarFilters,
    resetCalendarFilters,
    updateCalendarMonth,
  }
}
